import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Created with ♥ by <b><a href="https://multi-programming.com/" target="_blank">Multi-Programming Solutions</a></b> 2020
    </span>
  `,
})
export class FooterComponent {
}
